<template>
  <div>
    <serviceList
      :pageTitle="$t('featureServicePage.featureTitle')"
      :bannerUrl="bannerUrl"
      :characterList="characterList"
      :imgTextList="imgTextList"
    />
  </div>
</template>

<script setup>
import serviceList from '../../components/template/serviceList.vue';
import { useI18n } from 'vue-i18n'; 
const { t } = useI18n();
const bannerUrl = require('@assets/images/banner/besiness-feature-scope.png');
const characterList = [
  {
    img: require('@assets/icons/ico-feature_1.svg'),
    title: t('featureServicePage.feature1.title'),
    text: t('featureServicePage.feature1.text'),
  },
  {
    img: require('@assets/icons/ico-feature_2.svg'),
    title: t('featureServicePage.feature2.title'),
    text: t('featureServicePage.feature2.text'),
  },
  {
    img: require('@assets/icons/ico-feature_3.svg'),
    title: t('featureServicePage.feature3.title'),
    text: t('featureServicePage.feature3.text'),
  },
]
const imgTextList = [
  {
    img: require('@assets/images/service_img_1.png'),
    title: t('featureServicePage.description1.title'),
    text: t('featureServicePage.description1.text'),
  },
  {
    img: require('@assets/images/service_img_2.png'),
    title: t('featureServicePage.description2.title'),
    text: t('featureServicePage.description2.text'),
  },
  {
    img: require('@assets/images/service_img_3.png'),
    title: t('featureServicePage.description3.title'),
    text: t('featureServicePage.description3.text'),
  },
  {
    img: require('@assets/images/service_img_4.png'),
    title: t('featureServicePage.description4.title'),
    text: t('featureServicePage.description4.text'),
  },
  {
    img: require('@assets/images/service_img_5.png'),
    title: t('featureServicePage.description5.title'),
    text: t('featureServicePage.description5.text'),
  },
  {
    img: require('@assets/images/service_img_6.png'),
    title: t('featureServicePage.description6.title'),
    text: t('featureServicePage.description6.text'),
  },
]
</script>